import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';

const BubbleChart = (props) => {

  console.log("totalScores")
  console.log(props.totalScore)

  console.log("establishedYear")
  console.log(props.establishedYear)

  // Inside BubbleChart component

  // Scale a value from one range to another
  const scaleValue = (value, oldMin, oldMax, newMin, newMax) => {
    const scaledValue = ((newMax - newMin) * (value - oldMin)) / (oldMax - oldMin) + newMin;
    return parseFloat(scaledValue.toFixed(2)); 
  };

  /*
  ((5-4)*(70-998.6))/((497.81-998.6)+1)
  ((5-4)*(69-998.6))/((497.81-998.6)+1)
  ((5-4)*(85-998.6))/((497.81-998.6)+1)
  ((5-4)*(58-998.6))/((497.81-998.6)+1)
  ((5-4)*(30-998.6))/((497.81-998.6)+1)
  ((5-4)*(40-998.6))/((497.81-998.6)+1)
  */

  // Assuming your original value is 9986
  const originalValue = props.totalScore;

  // Scale the original value to the new range (1 to 5)
  //const scaledValue = scaleValue(originalValue, 9986, 49781, 1, 5);
  const scaledValue = (originalValue/100);

  const establishedYear = props.establishedYear;

  // Now the scaledValue will be between 1 and 5
  console.log("originalValue");
  console.log(originalValue);
  console.log("scaledValue");
  console.log(scaledValue);

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const options = {
      series: [
        {
          name: 'Outpost',
          data: [
            [1.5295, (currentYear - 2006), 3.31, "dfgh"],
            [1.83, (currentYear - 2003), 16.20],
            [1.877, (currentYear - 1999), 11.25],
            [1.882, (currentYear - 2012), 1.41],
            [1.957, (currentYear - 1996), 7.06],
            [1.962, (currentYear - 2007), 3.01],
          ],
        },
        {
          name: 'Satellite',
          data: [
            [2.008, (currentYear - 2004), 10.20],
            [2.0555, (currentYear - 2005), 18.13],
            [2.073, (currentYear - 2016), 1.74],
            [2.075, (currentYear - 2010), 11.03],
            [2.0995, (currentYear - 2003), 12.49],
            [2.112, (currentYear - 2005), 1.96],
            [2.127, (currentYear - 1995), 13.70],
            [2.154, 70, 1.22],
            [2.167, (currentYear - 2014), 11.85],
            [2.182, (currentYear - 2012), 5.35],
            [2.187, (currentYear - 2008), 6.29],
            [2.223, (currentYear - 2010), 3.51],
            [2.224, (currentYear - 2007), 8.38],
            [2.2245, (currentYear - 1999), 16.18],
            [2.247, (currentYear - 2011), 8.46],
            [2.264, (currentYear - 2004), 5.35],
            [2.312, (currentYear - 1999), 11.25],
            [2.312, (currentYear - 1999), 11.25],
            [2.323, (currentYear - 1996), 9.51],
            [2.336, (currentYear - 2015), 1.94],
            [2.34, (currentYear - 2015), 1.94],
            [2.352, (currentYear - 2003), 11.85],
            [2.357, (currentYear - 2003), 11.85],
            [2.364, (currentYear - 2005), 12.79],
            [2.369, (currentYear - 1999), 9.70],
            [2.374, (currentYear - 2005), 13.18],
            [2.382, 110, 1.44],
            [2.394, (currentYear - 2003), 5.10],
            [2.407, (currentYear - 1990), 6.62],
            [2.452, (currentYear - 2004), 29.70],
            [2.457, (currentYear - 2003), 9.87],
            [2.457, (currentYear - 2003), 9.87],
            [2.482, (currentYear - 2016), 8.91],
            [2.483, (currentYear - 2000), 17.36],
            [2.504, (currentYear - 2015), 2.76],
            [2.524, (currentYear - 2008), 4.97],
            [2.55, (currentYear - 1999), 21.99],
            [2.554, (currentYear - 2008), 12.95],
            [2.562, (currentYear - 2008), 13.40],
            // [2.604, 1999, 44.63],
            [2.61, (currentYear - 2013), 1.28],
            [2.624, (currentYear - 2008), 10.42],
            [2.634, (currentYear - 2015), 1.94],
            [2.657, (currentYear - 1997), 3.59],
            [2.682, (currentYear - 2003), 4.17],
            [2.687, (currentYear - 2004), 13.73],
            [2.695, (currentYear - 1997), 7.06],
            [2.734, (currentYear - 2001), 6.18],
            // [2.77, 1998, 34.94],
            // [2.777, 2001, 35.85],
            [2.78, (currentYear - 2003), 6.34],
            [2.817, (currentYear - 1995), 3.11],
            [2.824, (currentYear - 2001), 12.56],
            // [2.835, 1995, 52.35],
            [2.8495, (currentYear - 2006), 10.75],
            [2.854, (currentYear - 2006), 7.45],
            [2.872, (currentYear - 2004), 3.53],
            [2.909, (currentYear - 2002), 10.97],
            // [2.935, 1994, 35.57],
            [2.963, (currentYear - 1998), 6.29],
            [2.963, (currentYear - 2011), 2.74],
          ],
        },
        {
          name: 'Portfolio Hub',
          data: [
                [3.014, (currentYear - 1985), 8.22],
                [3.0245, (currentYear - 2004), 9.24],
                [3.025, (currentYear - 2002), 18.30],
                [3.025, (currentYear - 2006), 12.40],
                [3.033, (currentYear - 1996), 32.37],
                [3.033, (currentYear - 1996), 32.37],
                [3.07, (currentYear - 2019), 1.00],
                [3.07, (currentYear - 2019), 1.00],
                // [3.072, 1997, 34.94],
                [3.072, (currentYear - 2004), 9.43],
                [3.072, (currentYear - 2004), 9.43],
                [3.087, (currentYear - 1998), 21.33],
                [3.114, (currentYear - 2005), 15.17],
                [3.12, (currentYear - 1998), 1.88],
                [3.144, (currentYear - 2005), 10.70],
                [3.155, (currentYear - 2008), 1.66],
                [3.174, (currentYear - 2009), 13.20],
                [3.19, (currentYear - 2008), 5.90],
                [3.199, (currentYear - 2004), 1.83],
                [3.24, (currentYear - 1996), 1.80],
                [3.344, (currentYear - 2003), 8.82],
                // [3.38, 1996, 55.93],
                [3.387, (currentYear - 1998), 2.02],
                [3.4065, (currentYear - 1997), 11.08],
                [3.434, (currentYear - 1997), 3.92],
                // [3.437, 1998, 96.91],
                [3.452, (currentYear - 2005), 39.87],
                [3.48, (currentYear - 1995), 7.61],
                [3.49, (currentYear - 2005), 10.10],
                // [3.557, 1994, 85.59],
                // [3.559, 1998, 34.94],
                // [3.632, 2015, 44.58],
                // [3.645, 2003, 33.48],
                // [3.69, 1998, 36.64],
                // [3.7, 1999, 34.28],
                [3.76625, (currentYear - 1998), 21.33],
                [3.865, (currentYear - 2003), 4.14]
        ],
        },
        {
          name: 'Transformation Hub',
          data:[
            [4.044, (currentYear - 2002), 18.46],
            // [4.112, 1998, 74.65],
        ]
        },
        {
          name: 'Maturity Index',
          data:[
            [scaledValue, (currentYear - establishedYear) , 39],
          ]
        },
      ],
      chart: {
        height: 500,
        type: 'bubble',
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        opacity: 0.8,

      },
      // title: {
      //   text: 'Simple Bubble Chart',
      // },
      xaxis: {
        tickAmount: 4, 
        min: 1,
        max: 5,
        labels: {
          style: {
            colors: ['#FFF'],
            fontWeight: 'bold',
          }
        }
      },
      yaxis: {
        min: 0,
        max: 50,
        labels: {
          style: {
            colors: ['#FFF'],
            fontWeight: 'bold',
          }
        }
      },
      zaxis: {
        min: 1,
        max: 80,
      },
      grid: {
        column: {
          opacity: 0.5
        }, 
        xaxis: {
          lines: {
            show: true
          },
          
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        strokeDashArray: 7,
      },
      legend: {
        labels: {
          colors: [['white'], ['white'], ['white'], ['white'], ['white']],
          fontWeight: 'bold',
        }
      }
      
    };

    const chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, []);

  return <div id="chart" />;
};

export default BubbleChart;
